<template>
  <a :href="result.startup_website" target="_blank" class="search-result">
    <div class="search-result-title" v-html="result.title"></div>
    <div
      class="search-result-excerpt"
      v-html="result.startup_description"
    ></div>
    <div class="search-result-url">
      <i class="far fa-external-link"></i>
      {{ cleanUrl(result.startup_website) }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    result: Object
  },
  methods: {
    cleanUrl(url) {
      url = this.removeProtocol(url)
      return this.removeTrailingSlash(url)
    },
    removeProtocol(url) {
      return url.replace(/(^\w+:|^)\/\//, '')
    },
    removeTrailingSlash(url) {
      return url.replace(/\/$/, '')
    }
  }
}
</script>
